import { ConfigurationCommon } from "@vyne-shared/utils/config";

/** Configuration provided to the system at runtime. */
export class ConfigurationPaymentsUI extends ConfigurationCommon {
    constructor() {
        const rawConfig = window.__runtime_configuration;

        if (rawConfig.pkg !== "payments-ui") {
            throw new Error("incorrect package for configuration instance");
        }

        super();

        this.ldKey = rawConfig.ldKey;
        this.trellisAppUrl = rawConfig.trellisAppUrl;
    }

    /** The SDK key for LaunchDarkly. */
    readonly ldKey: string;

    /** The base URL for the Trellis App, so we can direct users to specific Trellis pages. */
    readonly trellisAppUrl: string;
}

/** The shared system configuration data. */
const configuration = new ConfigurationPaymentsUI();

export default configuration;
